import * as React from 'react';
import { IOtherProjectsProps } from '../types';
import * as styles from './OtherProjectsList.css';
import { BuilderInfo } from '../components';
import { Button } from '@cian/ui-kit';
import { useToggleState } from '@cian/react-utils';
import { ProjectItem } from './components/ProjectItem';

const COLLAPSED_PROJECTS_COUNT = 6;

export const OtherProjectsList: React.FC<IOtherProjectsProps> = ({
  items,
  company,
  onBuilderLinkClick,
  onProjectLinkClick,
  onProjectsListChange,
}) => {
  const { state: isExpanded, toggle } = useToggleState();

  const renderedItems = React.useMemo(
    () => (isExpanded ? items : items.slice(0, COLLAPSED_PROJECTS_COUNT)),
    [isExpanded, items],
  );

  const handleShowMore = React.useCallback(() => {
    toggle();
    onProjectsListChange();
  }, [toggle, onProjectsListChange]);

  return (
    <div className={styles['container']}>
      <BuilderInfo {...company} onClick={onBuilderLinkClick} />
      <div className={styles['list']}>
        {renderedItems.map((project, index) => (
          <ProjectItem {...project} key={project.id} onClick={() => onProjectLinkClick(project.id, index)} />
        ))}
      </div>
      {!isExpanded && items.length > COLLAPSED_PROJECTS_COUNT && (
        <div className={styles['expand-button']}>
          <Button theme="fill_secondary" onClick={handleShowMore} fullWidth>
            Еще объявления
          </Button>
        </div>
      )}
    </div>
  );
};
